// Side-channel carrying the RENDERED bytes of a failed print to the job
// record's catch site. printByteArray/printZpl know the bytes but the job
// records are created several frames up, where only the error is in scope;
// a WeakMap keyed by the error object attaches the bytes WITHOUT mutating
// the error or wrapping it in a new class (wrapping would break the
// `instanceof NativePrintError` / own-`retrySafety` reads at those sites).
const bytesByError = new WeakMap<object, number[]>();

export function attachFailedJobBytes(error: unknown, bytes: number[]): void {
  if (error && typeof error === 'object') {
    bytesByError.set(error, bytes);
  }
}

/** The rendered bytes of the print this error aborted, when known. */
export function failedJobBytesOf(error: unknown): number[] | undefined {
  return error && typeof error === 'object'
    ? bytesByError.get(error)
    : undefined;
}
